import React, { Component } from 'react';
import { observer } from "mobx-react";
import { action } from 'mobx';
import IconsContainer from "Utils/IconsContainer";
import 'Styles/MkMessaging/selectUsersModal.scss';
import MkMessagingStore from 'Stores/mkMessaging/mkMessagingStore';

class SelectUsersModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchAlias: ''
        }
    }

    render() {
        return (
            <div className='mk-messaging-select-user-modal-body'>
                <div className='mk-messaging-select-user-modal-available-users-holder'>
                    <div className='search-input-container'>
                        {IconsContainer.Get('ci-search')}
                        <input className='search-input'
                            value={this.state.searchAlias}
                            onChange={e => this.setState({ searchAlias: e.target.value })} />
                    </div>
                    <div className='user-list overflowing-element'>
                        {
                            Object.keys(MkMessagingStore.usersNamesByIdsDict).length == 0
                                ? (
                                    <div className='mk-messaging-user-list-placeholder'>
                                        Пользователи не найдены.<br/>
                                        Проверьте перечень синхронизированных пользователей
                                    </div>
                                )
                                : MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds.length >= Object.keys(MkMessagingStore.usersNamesByIdsDict).length
                                      ? (
                                          <div className='mk-messaging-user-list-placeholder'>
                                              Выбраны все пользователи
                                          </div>
                                      )
                                      : (
                                          MkMessagingStore.GetSelectedUsersByIds(MkMessagingStore.SelectUsersModalGetUsersIdsNotSelected())
                                              .filter(user => (
                                                  this.state.searchAlias == ""
                                                  ||
                                                  user.userName.toLowerCase().indexOf(this.state.searchAlias.toLowerCase()) >= 0
                                              ))
                                              .map(user => (
                                                  <div key={user.id}
                                                      className='mk-messaging-user'
                                                      onClick={action(_ => MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds.push(user.id))}>
                                                      <div className='user-name-container'>
                                                          {user.userName}
                                                      </div>
                                                      {IconsContainer.Get('ci-cross')}
                                                  </div>
                                              ))
                                      )
                        }
                    </div>
                </div>
                <div className='mk-messaging-select-user-modal-selected-users-holder user-list overflowing-element'>
                    {
                        MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds.length === 0
                            ? (
                                <div className='mk-messaging-user-list-placeholder'>
                                    Не выбран ни один пользователь
                                </div>
                            )
                            : MkMessagingStore.GetSelectedUsersByIds(MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds)
                                .map(user => (
                                    <div key={user.id}
                                        className='mk-messaging-user'
                                        onClick={action(_ => MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds = MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds.filter(it => it != user.id))}>
                                        <div className='user-name-container'>
                                            {user.userName}
                                        </div>
                                        {IconsContainer.Get('ci-cross')}
                                    </div>
                                ))
                    }
                </div>
            </div>
        )
    }
}

export default observer(SelectUsersModal);